import styled from '@emotion/styled';

interface AssetProps {
  id: string;
  imageUrl: string;
  handleAsset: (id: string) => void;
}

export default function Asset({ id, imageUrl, handleAsset }: AssetProps) {
  return (
    <Container onClick={() => handleAsset(id)}>
      <img src={imageUrl} alt={id} />
    </Container>
  );
}

const Container = styled.div`
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 4px;
  background: white;

  img {
    width: 100%;
    height: 100%;

    ${(props) => props.theme.mixins.aspectRatio.ratio1_1};
  }
`;
